import { AxiosError } from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { Results } from '../../types'
import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { Dataset } from './types'

type DatasetResults = Results<Dataset>

interface UseFetchDatasetsOptions {
  excludeTrainingId?: number
}

const useFetchDatasets = (
  productId: number,
  options?: UseFetchDatasetsOptions
) => {
  const { excludeTrainingId } = options ?? {}
  const [datasets, setDatasets] = useState<Dataset[] | undefined>(undefined)
  const [isFetching, setFetching] = useState(false)

  const fetchDatasets = useCallback(async () => {
    setFetching(true)
    const excludeParam = excludeTrainingId
      ? `&exclude_training=${excludeTrainingId}`
      : ''
    try {
      const data = await get<DatasetResults>(
        `/dataset/?product=${productId}&limit=1000${excludeParam}`
      )
      setDatasets(data.results)
      return data.results
    } catch (err) {
      handleApiErrors(err as AxiosError)
      return undefined
    } finally {
      setFetching(false)
    }
  }, [productId, excludeTrainingId])

  useEffect(() => {
    fetchDatasets()
  }, [fetchDatasets])

  return { datasets, isFetching, refetch: fetchDatasets }
}

export default useFetchDatasets
